module.exports = __webpack_public_path__ + "static/media/EmptyCheckBox.acc18294.svg";